import React from 'react'

const InStoreServices = ({ services }) => {
  return !services?.length ? null : (
    <section className="mb-4">
      <div className="mb-2">
        <h3 className="text-xl font-semibold">
          In-store services &amp; facilities
        </h3>
      </div>
      <section className="flex flex-wrap -mx-3">
        {services.map(s => {
          return s?.serviceName !== 'Bespoke Highlights' ? (
            <article
              key={s.name}
              title={s.serviceName}
              className="flex flex-col items-center justify-start w-1/4 px-3 mx-0 mb-8 lg:w-1/5"
            >
              <span
                className={`icon icon-Generic icon-${s.name}  text-4xl mb-2`}
              ></span>
              <span className={'text-base text-center leading-tight'}>
                {s.serviceName}
              </span>
            </article>
          ) : null
        })}
      </section>
    </section>
  )
}

export default InStoreServices
